import { DecodeVinResponse } from '@dav-model/api/response/decode-vin.response';
import { ManualResponse } from '@dav-model/api/response/manual.response';
import { PostalResponse } from '@dav-model/api/response/postal.response.model';
import { ProductFormResponse } from '@dav-model/api/response/product-form.response.model';
import { LoadQuote } from '@dav-model/cart/load-quote.model';
import { Action } from '@ngrx/store';

/**
 * vehicle store.
 * UI will call API and
 * get all form data to create formgroup.
 */
export const GET_PRODUCT_FORM = '[VEHICLE] GET PRODUCT FORM';
export const GET_PRODUCT_FORM_SUCCESS = '[VEHICLE] GET PRODUCT FORM SUCCESS';
export const RESET_PRODUCT_FORM = '[VEHICLE] RESET PRODUCT';
export const DECODE_VIN = '[VEHICLE] DECODE VIN';
export const DECODE_VIN_SUCCESS = '[VEHICLE] DECODE VIN SUCCESS';
export const DECODE_VIN_FAILURE = '[VEHICLE] DECODE VIN FAILURE';
export const GET_MAKE = '[VEHICLE] GET MAKE';
export const GET_MAKE_SUCCESS = '[VEHICLE] GET MAKE SUCCESS';
export const GET_YEAR = '[VEHICLE] GET YEAR';
export const GET_YEAR_SUCCESS = '[VEHICLE] GET YEAR SUCCESS';
export const GET_MODEL = '[VEHICLE] GET MODEL';
export const GET_MODEL_SUCCESS = '[VEHICLE] GET MODEL SUCCESS';
export const GET_TRIM = '[VEHICLE] GET TRIM';
export const GET_TRIM_SUCCESS = '[VEHICLE] GET TRIM SUCCESS';
export const SHOW_INSERVICE_DATE_AND_ODO = '[VEHICLE] SHOW INSERVICE DATE AND ODOMETER';
export const DECODE_VIN_MANUAL = '[VEHICLE] DECODE VIN MANUAL';
export const UPDATE_PRODUCT_FORM = '[VEHICLE] UPDATE PRODUCT FORM';
export const LOAD_VEHICLE_QUOTE = '[VEHICLE] LOAD VEHICLE QUOTE';
export const VEHICLE_FAILURE = '[VEHICLE] VEHICLE FAILURE';
export const GET_CUSTOMER_POSTAL = '[PRODUCT] GET CUSTOMER POSTAL';
export const CLEAR_CUSTOMER_POSTAL = '[PRODUCT] CLEAR CUSTOMER POSTAL';
export const GET_CUSTOMER_POSTAL_SUCCESS = '[PRODUCT] GET CUSTOMER POSTAL SUCCESS';
export const SET_VEHICLE_CONDITION = '[VEHICLE] SET VEHICLE CONDITION';
export const SET_CREDIT_STATUS = '[VEHICLE] SET_CREDIT_STATUS';
export const SET_SAVE_CREDIT = '[VEHICLE] SET_SAVE_CREDIT';

export class SetvehicleCondition implements Action {
  readonly type = SET_VEHICLE_CONDITION;

  constructor(public payload: boolean) {
  }
}

export class SetCreditInsurance implements Action {
  readonly type = SET_CREDIT_STATUS;

  constructor(public payload: boolean) {
  }
}

export class SetSaveCredit implements Action {
  readonly type = SET_SAVE_CREDIT;

  constructor(public payload: boolean) {
  }
}

export class GetProductFormAction implements Action {
  readonly type = GET_PRODUCT_FORM;
}

export class GetProductFormSuccessAction implements Action {
  readonly type = GET_PRODUCT_FORM_SUCCESS;

  constructor(public payload: ProductFormResponse) {
  }
}

export class UpdateProductFormAction implements Action {
  readonly type = UPDATE_PRODUCT_FORM;

  constructor(public payload: {}) {
  }
}

export class DecodeVinAction implements Action {
  readonly type = DECODE_VIN;

  constructor(public payload: string) {
  }
}

export class DecodeVinSuccessAction implements Action {
  readonly type = DECODE_VIN_SUCCESS;

  constructor(public payload: DecodeVinResponse) {
  }
}

export class DecodeVinFailureAction implements Action {
  readonly type = DECODE_VIN_FAILURE;

  constructor(public payload: DecodeVinResponse) {
  }
}

export class DecodeVinManualAction implements Action {
  readonly type = DECODE_VIN_MANUAL;

  constructor(public payload: ManualResponse) {
  }
}

export class GetYearAction implements Action {
  readonly type = GET_YEAR;

  constructor(public payload: { category: string }) {
  }
}

export class GetMakeAction implements Action {
  readonly type = GET_MAKE;

  constructor(public payload: { category: string; year: string }) {
  }
}

export class GetModelAction implements Action {
  readonly type = GET_MODEL;

  constructor(public payload: { category: string; year: string; make: string }) {
  }
}

export class GetTrimAction implements Action {
  readonly type = GET_TRIM;

  constructor(public payload: { category: string; year: string; make: string; model: string; }) {
  }
}

export class GetMakeSuccessAction implements Action {
  readonly type = GET_MAKE_SUCCESS;

  constructor(public payload: ManualResponse['make']) {
  }
}

export class GetYearSuccessAction implements Action {
  readonly type = GET_YEAR_SUCCESS;

  constructor(public payload: ManualResponse['year']) {
  }
}

export class GetModelSuccessAction implements Action {
  readonly type = GET_MODEL_SUCCESS;

  constructor(public payload: ManualResponse['model']) {
  }
}

export class GetTrimSuccessAction implements Action {
  readonly type = GET_TRIM_SUCCESS;

  constructor(public payload: ManualResponse['trim']) {
  }
}

export class ShowInsDateAndOdometerAction implements Action {
  readonly type = SHOW_INSERVICE_DATE_AND_ODO;
}

export class LoadVehicleQuoteAction implements Action {
  readonly type = LOAD_VEHICLE_QUOTE;

  constructor(public payload: LoadQuote) {
  }
}

export class VehicleFailureAction implements Action {
  readonly type = VEHICLE_FAILURE;

  constructor(public payload: any) {
  }
}

export class ResetProductFormAction implements Action {
  readonly type = RESET_PRODUCT_FORM;
}

export class GetCustomerPostalAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL;

  constructor(public payload: { zipCode: string }) {
  }
}

export class GetCustomerPostalSuccessAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {
  }
}

export class ClearCustomerPostalAction implements Action {
  readonly type = CLEAR_CUSTOMER_POSTAL;
}


export type All =
  | GetProductFormAction
  | GetProductFormSuccessAction
  | DecodeVinAction
  | DecodeVinSuccessAction
  | DecodeVinFailureAction
  | VehicleFailureAction
  | DecodeVinManualAction
  | GetMakeAction
  | GetYearAction
  | GetModelAction
  | GetTrimAction
  | GetMakeSuccessAction
  | GetYearSuccessAction
  | GetModelSuccessAction
  | GetTrimSuccessAction
  | ShowInsDateAndOdometerAction
  | SetvehicleCondition
  | SetCreditInsurance
  | SetSaveCredit
  | UpdateProductFormAction
  | ResetProductFormAction
  | LoadVehicleQuoteAction
  | GetCustomerPostalAction
  | GetCustomerPostalSuccessAction
  | ClearCustomerPostalAction;
